<p-toast></p-toast>

<div class="dashboardTable">
  <p-table #miSurvey [value]="miTableDataWithFilter" [rows]="10" [paginator]="true" responsiveLayout="scroll"
    [rowHover]="true" dataKey="appid" currentPageReportTemplate="{{ 'SHOWING' | translate }} {first} {{
    'TO' | translate
  }} {last} {{ 'OF' | translate }} {totalRecords} {{ 'ENTRIES' | translate }}" [showCurrentPageReport]="true"
    [loading]="loading" styleClass="p-datatable-gridlines" [tableStyle]="{ 'max-width': '80rem' }">
    <ng-template pTemplate="caption">
      <div class="grid d-flex align-items-center justify-content-end" style="background-color: #ffff">
        <!-- Left side -->
        <div class="col-6">
          <h5 class="m-0 table-header-text" [ngStyle]="{ color: 'black' }">
            {{ tableHeaderName | translate }}
          </h5>
        </div>
        <div class="col-12 md:col-6 gap-3 d-flex align-items-center justify-content-end">
          <span class="p-input-icon-left">
            <i class="pi pi-search"></i>
            <input pInputText type="text" placeholder="{{ 'SEARCH' | translate }}" />
          </span>
          <button (click)="menu.toggle($event)" pButton pRipple label="" icon="pi pi-download"
            class="p-button-help mx-1"></button>
          <p-menu #menu [popup]="true" [model]="miCompletedReport"></p-menu>
        </div>
      </div>
    </ng-template>

    <ng-template pTemplate="header">
      <tr>
        <!-- <th>{{ "S_NO" | translate }}</th> -->
        <th pSortableColumn="TicketNo">{{ "Ticket No" | translate }}</th>
        <th pSortableColumn="User_Id">{{ "USER_TYPE" | translate }}</th>
        <th pSortableColumn="User_Name">{{ "USER" | translate }}</th>
        <th pSortableColumn="Mobile_No">{{ "MOBILE_NO" | translate }}</th>
        <th pSortableColumn="EmailID">{{ "EMAIL" | translate }}</th>
        <th pSortableColumn="Address">{{ "ADDRESS" | translate }}</th>
        <th pSortableColumn="EmailID">{{ "GRIEVANCE_TYPE" | translate }}</th>
        <th pSortableColumn="BriefDescription">
          {{ "GRIEVANCE_DESCRIPTION" | translate }}
        </th>
        <th pSortableColumn="Date">{{ "DATE" | translate }}</th>
        <th pSortableColumn="Doc_Path">{{ "View Doc" | translate }}</th>
        <th pSortableColumn="Status">{{ "STATUS" | translate }}</th>
        <!-- <th>{{'VIEW' | translate}}</th> -->
        <th pSortableColumn="">{{ "ACTION" | translate }}</th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-consolidateData let-ri="rowIndex">
      <tr class="body-section">
        <!-- <td>{{ ri + 1 }}</td> -->
        <td><p-tag [value]="consolidateData.TicketNo" [severity]="getSeverity(consolidateData.Status)"></p-tag></td>
        <td>{{ consolidateData?.User_Id }}</td>
        <td>{{ consolidateData?.User_Name }}</td>
        <td>{{ consolidateData?.Mobile_No }}</td>
        <td>{{ consolidateData?.EmailID }}</td>
        <td>{{ consolidateData?.Address }}</td>
        <td>{{ consolidateData?.GrievanceType }}</td>
        <td>{{ consolidateData?.BriefDescription }}</td>
        <td>{{ consolidateData?.Date | date : "mediumDate" }}</td>
        <td>
          <a *ngIf="consolidateData?.Doc_Path && consolidateData?.Doc_Path != 'string'" style="cursor: pointer"
            icon="pi pi-eye" [href]="consolidateData?.Doc_Path" target="_blank">
            <button pButton type="button" class="p-button-rounded p-button-accent p-button-secondary p-button-rounded"
              pTooltip="View" icon="pi pi-eye"></button>
          </a>
        </td>
        <!-- <td>{{ consolidateData?.Status }}</td> -->

        <td><p-tag [value]="consolidateData.Status" [severity]="getSeverity(consolidateData.Status)"></p-tag></td>

        <td>
          <button *ngIf="consolidateData.Status == 'Active'" pButton pRipple type="button" pTooltip="Action"
            icon="pi pi-plus" class="p-button-rounded p-button-text" (click)="openDialog(consolidateData)"></button>
        </td>
      </tr>
    </ng-template>

    <ng-template pTemplate="footer"> </ng-template>
  </p-table>
</div>

<p-dialog [(visible)]="displayDialog" [modal]="true" [style]="{ width: '40%', height: '100%' }" [maximizable]="true"
  [draggable]="false" [resizable]="false" (onHide)="hideDialog()">
  <!-- <p-dialog
  header="Update Grievance"
  [(visible)]="displayDialog"
  [modal]="true"
  [closable]="true"
  [dismissableMask]="true"
  styleClass="p-fluid"
> -->
  <form [formGroup]="popup">
    <div class="p-fluid p-formgrid justify-content-center action-dialog" style="display: flex; flex-wrap:wrap">
      <div class="field md:col-12 col-12">
        <label for="ticketNo">Ticket Number</label>
        <input class="readonly" readonly="true" id="ticketNo" pInputText formControlName="ticket" [readonly]="true"
          style="color: rgb(168, 32, 32);" />
      </div>

      <div class="field md:col-12 col-12">
        <label for="briefDesc">Department Remarks</label>
        <textarea id="briefDesc" pInputTextarea rows="3" formControlName="description"></textarea>
      </div>

      <div class="field md:col-12 col-12">
        <label for="status">Status</label>
        <p-dropdown id="status" [options]="statusOptions" formControlName="status" optionLabel="label"></p-dropdown>
      </div>
    </div>

    <p-footer>
      <div class="row">

        <div class="col-6">
          <button pButton pRipple label="Save" icon="pi pi-check" (click)="saveChanges()"
            class="p-button-success"></button>
        </div>
        <div class="col-6">
          <button pButton pRipple label="Cancel" icon="pi pi-times" (click)="hideDialog()"
            class="p-button-secondary"></button>
        </div>

      </div>


    </p-footer>
  </form>
</p-dialog>